var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashNoCirclecomponent = function SvgTrashNoCirclecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0c-.735 0-1.333.628-1.333 1.4v.7H0v1.4h1.333v9.1c0 .772.598 1.4 1.334 1.4h6.666c.736 0 1.334-.628 1.334-1.4V3.5H12V2.1H9.333v-.7C9.333.628 8.735 0 8 0H4Zm4 1.4v.7H4v-.7h4ZM2.667 12.6V3.5h6.666v9.1H2.667Zm2.666-7.7v6.3H4V4.9h1.333ZM8 4.9v6.3H6.667V4.9H8Z",
    fill: "#A08264"
  })));
};
export default SvgTrashNoCirclecomponent;